import { EnrollmentPlanCSID } from "@/api/types";
import { useSelectedEnrollmentPlan } from "@/premium/hooks";
import { Dropdown } from "@/premium/themedComponents/Dropdown";
import { EnrollmentContext } from "@/state";
import { Icon } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { CSSProperties, FC, useCallback, useContext, useMemo, useState } from "react";
import { useSearchParams } from "react-router";
import "./PlanDropdown.scss";
const DropdownTitle: FC<{ readonly title: string; fontFamily: string }> = ({ title, fontFamily }) => {
  const style: CSSProperties = { fontFamily };

  return (
    <Shelf className="plan-dropdown-title-shelf">
      <h1 className="plan-dropdown-label" style={style}>{title}</h1>
      <Icon className="plan-dropdown-icon" name="chevron-down" />
    </Shelf>
  );
};


export const PlanDropdown: FC = () => {
  const { enrollmentPlanCsid } = useSelectedEnrollmentPlan();
  const [state] = useContext(EnrollmentContext);
  const [isOpen, setIsOpen] = useState(false);
  const [_, setSearchParams] = useSearchParams();
  const fontFamily = (state.experienceData?.theme as { font?: string } | undefined)?.font || "Source Sans 3";

  const dropdownTitle = useMemo(() => {
    return enrollmentPlanCsid?.display_name;
  }, [enrollmentPlanCsid]);

  const titlePressed = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const blurred = useCallback(() => {
    setIsOpen(false);
  }, []);

  const itemSelected = useCallback((item: EnrollmentPlanCSID, setPlan: boolean) => {
    if (setPlan) {
      setSearchParams((prev) => {
        const params: { [key: string]: string } = {};
        prev.forEach((value, key) => {
          params[key] = value;
        });
        params["enrollmentPlan"] = item.id.toString();
        return params;
      });
    }
    setIsOpen(false);
  }, [setSearchParams]);

  return (
    <Dropdown isOpen={isOpen} onBlur={blurred} onClick={titlePressed} label={
      <DropdownTitle title={dropdownTitle} fontFamily={fontFamily} />
    }>
      {state.experienceData.plan_csids.map((ep) => {
        if (ep.id === enrollmentPlanCsid?.id) {
          return <h3 className="plan-dropdown-item" style={{ fontFamily }} key={ep.id} onClick={() => itemSelected(ep, false)}><b>{enrollmentPlanCsid?.display_name}</b></h3>;
        } else {
          return <h3 className="plan-dropdown-item" style={{ fontFamily }} key={ep.id} onClick={() => itemSelected(ep, true)}>{ep.display_name}</h3>;
        }
      })}
    </Dropdown>
  );
};
